import API from '../../../constants/api';

export const FETCH_ISSUE_INVOICE_LIST_REQUEST = '@@issueInvoice/FETCH_ISSUE_INVOICE_LIST_REQUEST';
export const FETCH_ISSUE_INVOICE_LIST_FAILURE = '@@issueInvoice/FETCH_ISSUE_INVOICE_LIST_FAILURE';
export const FETCH_ISSUE_INVOICE_LIST_SUCCESS = '@@issueInvoice/FETCH_ISSUE_INVOICE_LIST_SUCCESS';

export const fetchIssueInvoices = (page, size, filters, searchFilter, seekDirection, seekParams) => ({
    type: FETCH_ISSUE_INVOICE_LIST_REQUEST,
    api: API.BUNDLES.GET_INVOICES,
    page,
    size,
    filters,
    searchFilter,
    seekDirection,
    seekParams,
});
